import React from 'react';
import propTypes from 'prop-types';
export const AirplaneOutlineIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      height={sizeInPixel}
      width={sizeInPixel}
      fill={color}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 330 330"
      enableBackground="new 0 0 330 330"
      xmlSpace="preserve"
    >
      <path
        id="XMLID_521_"
        d="M297.541,122.634c-17.068-8.147-39.274-12.634-62.627-12.633l-9.416,0.062L189.111,9.879
   C186.958,3.949,181.322,0,175.013,0h-60c-4.619,0-8.98,2.128-11.823,5.769c-2.843,3.641-3.85,8.388-2.729,12.869L125.801,120
   h-21.518L88.429,88.292C85.889,83.21,80.694,80,75.013,80h-60c-5.042,0-9.747,2.533-12.523,6.743
   c-2.775,4.209-3.251,9.532-1.265,14.166L28.693,165L1.226,229.091c-1.986,4.634-1.511,9.957,1.265,14.166
   C5.266,247.467,9.971,250,15.013,250h60c5.682,0,10.876-3.21,13.416-8.292L104.283,210h21.518l-25.34,101.362
   c-1.121,4.482-0.114,9.229,2.729,12.869c2.843,3.641,7.204,5.769,11.823,5.769h60c6.308,0,11.941-3.946,14.097-9.874L225.519,220
   h9.493c46.685,0,94.975-20.895,94.975-55.86C329.987,147.362,318.464,132.621,297.541,122.634z M235.013,190h-20
   c-6.308,0-11.941,3.946-14.097,9.874L164.506,300h-30.281l25.34-101.362c1.121-4.482,0.114-9.229-2.729-12.869
   c-2.843-3.641-7.204-5.769-11.823-5.769h-50c-5.682,0-10.876,3.21-13.416,8.292L65.742,220H37.761L58.8,170.909
   c1.617-3.773,1.617-8.044,0-11.817L37.761,110h27.981l15.854,31.708c2.54,5.082,7.734,8.292,13.416,8.292h50
   c4.619,0,8.98-2.128,11.823-5.769c2.843-3.641,3.85-8.388,2.729-12.869L134.225,30h30.277l36.412,100.252
   c2.155,5.934,7.792,9.88,14.098,9.879c0.033,0,0.067,0,0.1-0.001L235.013,140c40.306,0,64.975,15.629,64.975,24.14
   C299.987,173.257,275.318,190,235.013,190z"
      />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
AirplaneOutlineIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
AirplaneOutlineIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
